import { MessageType } from '../../store/features/messages';
import { store } from '../../store/store';
import { loadAndInstallExtension } from './index';
import { extensionHandlers } from './sdk';
export const messageHandler = async () => {
    const state = store.getState();
    const { extensionMessage } = state.messages;
    if (extensionMessage) {
        switch (extensionMessage.type) {
            case MessageType.INSTALL_EXTENSION:
                await loadAndInstallExtension(extensionMessage.extensionName, extensionMessage.extensionCode);
                break;
            case MessageType.ACTION_REQUEST:
                loadAndInstallExtension(extensionMessage.extensionName, extensionMessage.extensionCode).then(() => {
                    const handler = extensionHandlers.get(extensionMessage.handlerType);
                    if (handler) {
                        handler(extensionMessage.data);
                    }
                });
                break;
            default:
                break;
        }
    }
};
